import { useState } from 'react';
import { ChatBubbleLeftEllipsisIcon } from '@heroicons/react/24/outline';
import IssueReporterModal from './IssueReporterModal';

const IssueReporterButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Report an issue"
        title="Report an issue"
        data-issue-reporter="button"
        className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-wrg-blue-500"
      >
        <ChatBubbleLeftEllipsisIcon className="size-6" aria-hidden="true" />
      </button>
      <IssueReporterModal isOpen={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default IssueReporterButton;
